import { render, staticRenderFns } from "./SortableFileUploader.vue?vue&type=template&id=5f01843c&scoped=true"
import script from "./SortableFileUploader.vue?vue&type=script&lang=js"
export * from "./SortableFileUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f01843c",
  null
  
)

export default component.exports